// SPDX-FileCopyrightText: 2022 Genome Research Ltd.
//
// SPDX-License-Identifier: MIT
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createAxiosInstance } from './axios';
import { CONFIG } from './config';
var authApi = createAxiosInstance(CONFIG);
function normalizeBody(data) {
    if (!(data instanceof FormData)) {
        if (typeof data === 'object' && data != null) {
            data = JSON.stringify(data);
        }
    }
    return data;
}
function wrapClientWithContext(client, accessToken) {
    if (accessToken === void 0) { accessToken = ''; }
    var authHeader = accessToken ? { "Token": "".concat(accessToken) } : {};
    var defaultOption = {
        headers: __assign(__assign({}, CONFIG.headers), authHeader),
    };
    return {
        get: function (endPoint, options) {
            if (options === void 0) { options = {}; }
            return client.get(endPoint, __assign(__assign({}, defaultOption), options));
        },
        post: function (endPoint, data, options) {
            if (options === void 0) { options = {}; }
            data = normalizeBody(data);
            return client.post(endPoint, data, __assign(__assign({}, defaultOption), options));
        },
        put: function (endPoint, data, options) {
            if (options === void 0) { options = {}; }
            data = normalizeBody(data);
            return client.put(endPoint, data, __assign(__assign({}, defaultOption), options));
        },
        patch: function (endPoint, data, options) {
            if (options === void 0) { options = {}; }
            data = normalizeBody(data);
            return client.patch(endPoint, data, __assign(__assign({}, defaultOption), options));
        },
        delete: function (endPoint, options) {
            if (options === void 0) { options = {}; }
            return client.delete(endPoint, __assign(__assign({}, defaultOption), options));
        },
        client: client,
    };
}
export function httpServices(accessToken) {
    if (accessToken === void 0) { accessToken = ''; }
    return wrapClientWithContext(authApi, accessToken);
}
